import React from 'react';

export default function WatermarkOverlay({ text = "BPA Solutions – Demonstration" }) {
  return (
    <div className="absolute inset-0 pointer-events-none z-20 overflow-hidden select-none opacity-[0.08]">
      <div 
        className="w-[200%] h-[200%] -translate-x-1/4 -translate-y-1/4 rotate-[-30deg] flex flex-wrap content-start justify-start gap-x-24 gap-y-32"
        style={{ userSelect: 'none' }}
      >
        {Array.from({ length: 100 }).map((_, i) => (
          <span 
            key={i} 
            className="text-slate-900 font-sans font-bold text-sm whitespace-nowrap tracking-wider uppercase"
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}